import moment from "moment";
import { useSelector } from "react-redux";
import { createRef, useEffect } from "react";

import { timeSlots } from "../../utils/utils";
import CalendarDaysOfWeek from "./CalendarDaysOfWeek";
import DayCalendarSchedules from "./DayCalendarSchedules";
import DayCalendarSchedulesManagement from "./DayCalendarSchedulesManagement";

function MonthCalendar({ calendarObj }) {
  const weekBoxRef = createRef();
  const { user } = useSelector((state) => state.userReducer);
  const { selectedStart } = useSelector((state) => state.calendarReducer);

  const { schedules, onSchedulesClick, onScheduleClick } = calendarObj;

  const rows = [];
  let counter = 0;
  for (const time in timeSlots) {
    const daySchedules = schedules.filter((item) => item.scheduledDate === moment(selectedStart).format("YYYY-MM-DD"));
    const timeSchedules = daySchedules
      .filter((item) => item.scheduledStartTime.slice(0, 5) === timeSlots[time])
      .sort((a, b) => {
        if (a.status > b.status) return -1;
        if (a.status < b.status) return 1;
        return 0;
      });

    rows.push(
      <div className="dayTimeBox" key={"dayTimeBox" + counter}>
        {timeSlots[time].slice(3, 4) !== "3" && (
          <p className="dayCalendarTime">{moment(`2019-05-02 ${timeSlots[time]}`).format("h a")}</p>
        )}
        <div key={"dayT" + counter} className={`dayTime`}>
          {user?.role === "student" || user?.role === "teacher" ? (
            <DayCalendarSchedules timeSchedules={timeSchedules} onScheduleClick={onScheduleClick} />
          ) : (
            <DayCalendarSchedulesManagement
              timeSchedules={timeSchedules}
              onSchedulesClick={onSchedulesClick}
              onScheduleClick={onScheduleClick}
            />
          )}
        </div>
      </div>,
    );
    counter++;
  }

  useEffect(() => {
    weekBoxRef.current.scrollTop = 594;
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <CalendarDaysOfWeek calendarObj={calendarObj} />
      <div key={"CalendarOfDay"} className="dayBox" ref={weekBoxRef}>
        {rows}
      </div>
    </>
  );
}

export default MonthCalendar;
